import moment from "moment";

export const displayDate = (value: string): string => {
    return `${moment(value).format('DD MMM YYYY')}`
}